import { render } from "./DescriptionCapital.vue?vue&type=template&id=608e8862&scoped=true"
import script from "./DescriptionCapital.vue?vue&type=script&lang=js"
export * from "./DescriptionCapital.vue?vue&type=script&lang=js"

import "./DescriptionCapital.vue?vue&type=style&index=0&id=608e8862&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e8862"]])

export default __exports__